export default {
  back: 'Back',
  next: 'Next',
  loading: 'Loading survey...',
  loadError: 'Error loading survey',
  loadErrorMessage:
    'The survey could not be loaded. Please try again later or contact support.',
  sendError: 'Error sending data:',
  generalError: 'An error occurred. Please try again later.',
  analyzing: 'Analyzing your answers...',
  pleaseWait: 'Please wait a moment',
  defaultThankYou: 'Thank you for your participation!',
  thankYouTitle: 'Thank you!',
  answersSubmitted: 'Your answers were submitted successfully.',
  redirectingIn: 'You will be redirected in {n} second{s}...',
  redirectNow: 'Redirect now',
  defaultThankYouHtml:
    '<h2>Thank you!</h2><p>Thank you for your participation. We will get back to you shortly.</p>',
  emailInvalid: 'Please enter a valid email address.',
  requiredField: 'This is a required field',
  emailInvalidShort: 'Not a valid email address.',
  checkInputs: 'Please check your inputs.',
  requiredLabel: 'Required field',
  formAriaLabel: 'Submit form',
  selectPlaceholder: 'Please select an option...',
  answerPlaceholder: 'Answer...',
  multiChoiceBetween: 'Select between {min} and {max} options.',
  multiChoiceMin: 'Select at least {min} option(s).',
  multiChoiceMax: 'Select at most {max} option(s).',
  multiChoiceSelected: '{count} option(s) selected',
  fieldRequired: 'This field is required',
  numberInvalid: 'Please enter a valid number',
  numberMin: 'At least {min}',
  numberMax: 'At most {max} {unit}',
  sliderRequired: 'Please select a value',
  selectRequired: 'Please select an option',
  multiChoiceRequired: 'Please select at least one option',
  multiChoiceMinRequired: 'At least {min} option(s) required',
  multiChoiceMaxAllowed: 'At most {max} option(s) allowed',
} as Record<string, string>
